/********************** Custom components *********************/
import App from './components/app';

/************************* Style Files ************************/
import './style';

export default App;



// WEBPACK FOOTER //
// ./index.js